<template>
  <div class="card bs-shadow br4 mb8" style="margin-bottom: 8px">
    <div
      :id="index === 0 ? 'st-step-5' : ''"
      class="card-name"
      style="display: flex; padding: 10px"
      v-if="listView"
    >
      <p class="mrauto mb0" style="max-width: 70%">
        <span
          v-if="el.security.asset_groups.includes('Confidential Documents')"
          class="badge badge-orange"
          style="margin-right: 5px; font-size: inherit"
          >CONFIDENTIAL</span
        ><span>{{ el.filename }}</span>
      </p>

      <!--- ################# start issue solved Virtual dom injecting spans, changed all spans to divs #################### -->
      <div
        class="button-wrap"
        v-if="el.file_properties['format_type'] == 'image' && listView"
      >
        <a
          class="links mr5"
          v-on:click="showLightbox(el.thumbnails['600px'].url)"
        >
          <i
            class="material-icons"
            data-toogle="tooltip"
            title="Preview this image"
            >visibility</i
          >
        </a>

        <a
          v-if="
            !el.security.asset_groups.includes('Confidential Documents') &&
            showCopy &&
            el.file_properties['format_type'] == 'image' &&
            listView
          "
          class="links mr5"
          :href="el.embeds['original'].url"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i
            class="material-icons"
            aria-hidden="true"
            data-toogle="tooltip"
            title="Download this image"
          >
            sim_card_download</i
          >
        </a>

        <a
          v-if="
            !el.security.asset_groups.includes('Confidential Documents') &&
            showCopy &&
            el.file_properties['format_type'] == 'image' &&
            listView
          "
          class="links mr5"
          v-clipboard="el.embeds['original'].share"
          v-on:click="copyLink"
        >
          <i
            class="material-icons"
            data-toogle="tooltip"
            title="Copy this file location"
            >file_copy</i
          >
        </a>

        <a
          v-if="
            !el.security.asset_groups.includes('Confidential Documents') &&
            showCopy &&
            el.file_properties['format_type'] == 'image' &&
            listView
          "
          class="links"
          :href="`mailto:?subject=Link&body=${el.embeds['original'].share}`"
        >
          <i
            class="material-icons"
            data-toogle="tooltip"
            title="Email this file"
            >send</i
          >
        </a>
      </div>

      <div
        class="button-wrap"
        v-else-if="
          (el.file_properties['format_type'] == 'pdf') |
            (el.file_properties['format_type'] == 'office')
        "
      >
        <a
          v-if="!el.security.asset_groups.includes('Confidential Documents')"
          @click="
            showEula(el.embeds['document_viewer_with_download'].url, 'download')
          "
          target="_blank"
          class="mr5 links"
        >
          <i
            class="material-icons"
            data-toogle="tooltip"
            title="Preview this PDF"
            >visibility</i
          >
        </a>
        <a
          v-else
          class="mr5 links"
          @click="showLightboxConf(el.embeds['document_html5_viewer'].url)"
        >
          <i
            class="material-icons"
            data-toogle="tooltip"
            title="Preview this PDF"
            >visibility</i
          >
        </a>

        <a
          v-if="
            !el.security.asset_groups.includes('Confidential Documents') &&
            showCopy
          "
          class="links mr5"
          :href="el.embeds['original'].share"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i
            class="material-icons"
            aria-hidden="true"
            data-toogle="tooltip"
            title="Download this Document"
          >
            sim_card_download</i
          >
        </a>

        <a
          v-if="
            !el.security.asset_groups.includes('Confidential Documents') &&
            showCopy
          "
          class="links mr5"
          v-clipboard="el.embeds['original'].share"
          v-on:click="copyLink"
        >
          <i
            class="material-icons"
            data-toogle="tooltip"
            title="Copy this file location"
            >file_copy</i
          >
        </a>

        <a
          v-if="
            !el.security.asset_groups.includes('Confidential Documents') &&
            showCopy
          "
          class="links"
          :href="`mailto:?subject=Link&body=${el.embeds['original'].share}`"
        >
          <i
            class="material-icons"
            data-toogle="tooltip"
            title="Email this file"
            >send</i
          >
        </a>
      </div>

      <div
        class="button-wrap"
        v-else-if="el.file_properties['format_type'] == 'video'"
      >
        <a
          class="links mr5"
          v-on:click="showLightboxVideo(el.embeds['video_player'].html)"
        >
          <i
            class="material-icons"
            data-toogle="tooltip"
            title="Preview this video"
            >visibility</i
          >
        </a>

        <a
          v-if="
            !el.security.asset_groups.includes('Confidential Documents') &&
            showCopy
          "
          class="links mr5"
          v-clipboard="el.embeds['video_player'].url"
          v-on:click="copyLink"
        >
          <i
            class="material-icons"
            data-toogle="tooltip"
            title="Copy this file location"
            >file_copy</i
          >
        </a>

        <a
          v-if="
            !el.security.asset_groups.includes('Confidential Documents') &&
            showCopy
          "
          class="links"
          :href="`mailto:?subject=Link&body=${el.embeds['video_player'].url}`"
        >
          <i
            class="material-icons"
            data-toogle="tooltip"
            title="Email this file"
            >send</i
          >
        </a>
      </div>

      <div
        class="button-wrap"
        v-else-if="el.file_properties['format_type'] == 'compressed_archive' || el.file_properties['format'] == 'PdfArchive'"
        style="margin-bottom: 5px"
      >
        <a
          v-if="!showCopy"
          @click="showEula(el.embeds['original'].share, 'download')"
          class="links ml-auto mr5 center"
        >
          <i
            class="material-icons"
            aria-hidden="true"
            data-toogle="tooltip"
            title="Download this zip archive"
          >
            sim_card_download</i
          >
        </a>

        <a
          v-else
          class="links mr5 ml-auto center"
          :href="el.embeds['original'].share"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i
            class="material-icons"
            aria-hidden="true"
            data-toogle="tooltip"
            title="Download this zip archive"
          >
            sim_card_download</i
          >
        </a>

        <a
          v-if="
            !el.security.asset_groups.includes('Confidential Documents') &&
            showCopy
          "
          class="links mr5"
          v-clipboard="el.embeds['original'].share"
          v-on:click="copyLink"
        >
          <i
            class="material-icons"
            data-toogle="tooltip"
            title="Copy this file location"
            >file_copy</i
          >
        </a>

        <a
          v-if="
            !el.security.asset_groups.includes('Confidential Documents') &&
            showCopy
          "
          class="links"
          :href="`mailto:?subject=Link&body=${el.embeds['original'].share}`"
        >
          <i
            class="material-icons"
            data-toogle="tooltip"
            title="Email this file"
            >send</i
          >
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MediaListCard",
  props: {
    // Define a prop named 'el' with type 'any'
    listView: Boolean,
    showCopy: Boolean,
    index: Number,
    el: {
      type: [String, Number, Object, Array, Boolean, Function],
      default: null,
      required: true
    },
    copyLink: {
      type: Function,
    },
    showLightbox: {
      type: Function,
    },
    showLightboxVideo: {
       type: Function,
    },
  },
  methods: {
    showEula: function (link, type) {
		let fileLocation = link;
		let action = type;
		if (this.$store.state.eulaAccepted == false) {

			this.$swal({
				html:
					'<p style="margin-bottom: 0">Policy and Usage Guidelines</p>' +
					'<p><small>for Assets Owned by Spacesaver</small></p>' +
					'<div style="overflow:scroll; max-height: 300px; text-align: left;"><small>' +
					'<p>In order to use any Spacesaver asset(s) you must submit final materials containing Spacesaver assets to spacesavermktg@spacesaver.com.</p>' +
					'<p>This is a license, not a sale. By using Spacesaver assets or exercising any rights granted under this End-User License Agreement, you agree to be bound by this End-User License Agreement. If you do not wish to accept the terms of this End-User License Agreement, do not use any Spacesaver assets and cease using any previously acquired Spacesaver assets immediately.</p><p>Who can use Spacesaver images: Only the following persons may use Spacesaver assets: Spacesaver Employee: a person that is currently employed by Spacesaver at the time of use. Distributor/Area Contractor Employee: a person that is currently employed by a Spacesaver Area Contractor at the time of use. Agency: Any outside agency that is hired by Spacesaver or Area Contractor(s) to promote Spacesaver at the time of use. Media: Magazines or newspapers that are editorializing Spacesaver or an Area Contractor at the time of use.</p><p>How Spacesaver assets may be used:</p><p>Length of Use Spacesaver assets may be used only for so long as they are furnished on this site. Images that no longer depict the true light of our products are not intended for use and will be eliminated from the site. It is our expectation that you will cease from using images no longer found on this site. Your rights to use any Spacesaver assets shall terminate immediately if you fail to comply with any of these terms and conditions as defined above.</p><p>Term and Termination You acknowledge that Spacesaver may terminate your right to access and use the Spacesaver assets at any time.</p><p>Restrictions on the Use of Spacesaver images You may not use any Spacesaver image for any purpose other than commercial promotion of Spacesaver products. The rights granted in this license apply only to Spacesaver assets that are provided by the Spacesaver asset management website located at spacesaver.widencollective.com, and Spacesaver reserves all rights not specifically granted. In order to use any Spacesaver asset(s) you must submit final materials containing Spacesaver assets to spacesavermktg@spacesaver.com. You shall not use any Spacesaver asset(s) in conjunction with any competitive products you might distribute. You are solely responsible for the use of any Spacesaver asset in combination with any other material.</p><p>Spacesaver assets may not be utilized as a trademark or service mark, for any unlawful purpose or use, to defame any person, to violate any person\'s right of privacy or publicity, to infringe upon any copyright, trade name, trademark, or service mark of any person/entity, or for uses covering sensitive subjects including, without limitation, topics that may depict the subject matter of a Spacesaver asset in a negative or unfavorable light or subject persons to ridicule, or the disparagement of a person or product. If you wish to make use of a Spacesaver asset in a manner not permitted by this license, please contact a Spacesaver marketing representative. Submit inquires to spacesavermktg@spacesaver.com.</p><p>Usage Guidelines The rights granted to you herein are conditioned upon your understanding and abiding by appropriate guidelines regarding lawful and unlawful uses of copyrights, trademarks, rights of publicity and moral rights (“Usage Guidelines”), which you should have received with this End-User License Agreement.</p><p>Ownership and Intellectual Property Spacesaver and its asset sources retain all right, title, and interest in and to all of the copyrights, patent rights, trademarks, trade secrets, and all other proprietary rights in the Spacesaver assets. You will not remove any copyright or other proprietary rights notices contained in the Spacesaver images or any related materials provided to you. No rights in the Spacesaver images are granted except the limited license contained in this End-User License Agreement. Any right, title or interest arising in any compilation or derivative work created using a Spacesaver asset shall not entitle you to use any Spacesaver asset except as permitted hereunder. You shall indemnify and defend Spacesaver and its image providers against all claims, liability, damages, costs and expenses, including reasonable legal fees and expenses, arising out of or related to (i) a breach of this Agreement, (ii) the use or modification of any Spacesaver asset or combination of any asset with any other material, (iii) your failure to abide by any restriction regarding the use of a Spacesaver asset, or (iv) any claim by a third party related to the use of a Spacesaver asset, alone or in combination with any other material.</p><p>Spacesaver makes no warranties nor shall be liable for any image which: (a) has been modified by you (b) has been combined by you with other images, products, content or materials, or (c) Spacesaver has previously notified you not to license or otherwise use.</p><p>Neither Spacesaver nor any of its directors, officers, employees, partners, licensors, or agents shall be liable for any indirect, consequential punitive, or incidental damages arising out of the use of, or the inability to use a Spacesaver asset, even if Spacesaver has been advised of the possibility of such damages. In no event shall Spacesaver’s liability (whether in tort, contract, or otherwise) arising out of or relating to your use of a Spacesaver image exceed U.S. $100.00, regardless of the number of claims or Spacesaver asset used.</p>' +
					'</small></div>',
				showCloseButton: true,
				showCancelButton: true,
				confirmButtonText: `I Agree`,
				denyButtonText: `No`,
				customClass: {
					cancelButton: 'order-1 right-gap',
					confirmButton: 'order-2',
				}
			}).then((result) => {
				if (result.isConfirmed) {
					//this.eulaAccepted = true;
					this.$store.commit("ACCEPT_EULA");
					this.$toast.success("All document capability is now enabled!", {
            hideProgressBar: false,
            icon: false,
          });
					//console.log(action);
					//this.$swal('Saved!', '', 'success')
					if (action == 'download') {
						window.open(fileLocation, "_blank");
					} else if (action == 'mail') {
						location.href = `mailto:?subject=Link&body=${fileLocation}`;
					} else if (action == 'preview') {
						//this.triggerLightbox(fileLocation);
						console.log(`preview ${fileLocation}`);
						return fileLocation;
					} else if (action == 'confvid') {
						//this.triggerLightbox(fileLocation);
						console.log(`conf vid ${fileLocation}`);
						return fileLocation;
					} else if (action == 'confdoc') {
						//this.lightboxConfidential = link;
						console.log(`conf doc ${fileLocation}`);
						return fileLocation;
						//this.$store.commit("UPDATE_LIGHTBOX_CONF_SALES_TRAINING", fileLocation);
					}
				} else {
					this.$toast.error("Media usage agreement must be accepted for full functionality.", {
            hideProgressBar: false,
            icon: false,
          });
					return '';
				}
			});

		} else {
			if (action == 'download') {
				window.open(fileLocation, "_blank");
			} else if (action == 'mail') {
				location.href = `mailto:?subject=Link&body=${fileLocation}`;
			} else if (action == 'preview') {
				this.triggerLightbox(fileLocation);
			}
		}
	},
	triggerLightbox: function (media) {
		return media;
	},
    truncateTitle: function (value) {
      if (value.length > 35) {
        value = value.substring(0, 55) + "...";
      }
      return value;
    },
    truncateExcerpt: function (value) {
      if (value.length > 85) {
        value = value.substring(0, 85) + "...";
      }
      return value;
    },
  },
};
</script>

<style scoped></style>
